import { render, staticRenderFns } from "./VaultCategoryItem.vue?vue&type=template&id=0906513f&scoped=true&"
import script from "./VaultCategoryItem.vue?vue&type=script&lang=ts&"
export * from "./VaultCategoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./VaultCategoryItem.vue?vue&type=style&index=0&id=0906513f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906513f",
  null
  
)

export default component.exports